var exports = {
  "kL": "AvatarWithPresence.module__container___RTBKZm",
  "_V": "AvatarWithPresence.module__containerSpeaking___RTBKZm",
  "V5": "AvatarWithPresence.module__voiceIndicatorIcon___RTBKZm",
};

module.exports = exports;
